/**
 *
 * UploadPage
 *
 */

import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { useCurrentUser } from 'containers/User';
import { Wrapper } from 'containers/KmVretersPage';
import Container from 'components/KmVreters/Container';
import MetaTags from 'components/MetaTags';
import Spinner from 'components/Spinner';
import Footer from 'components/Footer';
import FileRow from './FileRow';
import useGpxBatchUpload from './useGpxBatchUpload';
import messages from './messages';

const FileInputLabel = styled.label`
  [type='file'] {
    border: 0;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute !important;
    white-space: nowrap;
    width: 1px;
  }
`;

const FileList = styled.ul`
  margin-top: 15px;
  padding-left: 0;
  list-style: none;
`;

function renderBody(user, files, handleChange) {
  if (user.loading) {
    return <Spinner />;
  }
  if (!user.email) {
    return (
      <p>
        <FormattedHTMLMessage {...messages.signInRequired} />
      </p>
    );
  }
  return (
    <>
      <p>
        <FormattedMessage {...messages.intro} />
      </p>
      <FileInputLabel
        className="btn btn-default px-2"
        htmlFor="gpx-upload-input"
      >
        <FormattedMessage {...messages.chooseFiles} />
        <input
          type="file"
          id="gpx-upload-input"
          accept=".gpx"
          multiple
          onChange={handleChange}
        />
      </FileInputLabel>
      {files.length > 0 && (
        <FileList>
          {files.map(entry => <FileRow key={entry.id} entry={entry} />)}
        </FileList>
      )}
    </>
  );
}

function UploadPage() {
  const user = useCurrentUser();
  const { files, addFiles } = useGpxBatchUpload(user);

  function handleChange(ev) {
    addFiles(ev.target.files);
    ev.target.value = ''; // eslint-disable-line no-param-reassign
  }

  const tags = { title: messages.title, description: messages.description };
  return (
    <Wrapper>
      <MetaTags tags={tags} />
      <Container width={720}>
        <Container.Header>
          <FormattedMessage {...messages.header} />
        </Container.Header>
        {renderBody(user, files, handleChange)}
      </Container>
      <Footer />
    </Wrapper>
  );
}

export default UploadPage;
